/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't send your feedback. Please try again." |
*
* @param {Feedback_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_error = /** @type {((inputs?: Feedback_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'envoyer votre commentaire. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha podido enviar el comentario. Inténtelo de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível enviar o feedback. Tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare il feedback. Riprova.")
	return /** @type {LocalizedString} */ ("Couldn't send your feedback. Please try again.")
});